import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { ESC_SEARCH_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class SearchEscRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {};

  url = ESC_SEARCH_URL;

  constructor(data) {
    super();
    this.body = data;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
